import React from 'react';
import { MessageSquare, Package } from 'lucide-react';

export function CrewEquipmentWorkspace({
  handlesEquipment,
  pickupContent,
  crewNotes,
  onCrewNotesChange,
  onCrewNotesSave,
}: {
  handlesEquipment: boolean;
  pickupContent?: React.ReactNode;
  crewNotes: string;
  onCrewNotesChange: (value: string) => void;
  onCrewNotesSave: (value: string) => void | Promise<void>;
}) {
  return (
    <div className="space-y-6 animate-fade-in">
      <section aria-labelledby="shift-equipment-heading" className="space-y-3">
        <h3 id="shift-equipment-heading" className="flex items-center gap-2 border-b border-brand-neonBlue/20 px-2 pb-3 text-[11px] font-black uppercase tracking-[0.2em] text-brand-neonBlue">
          <Package size={14} /> Equipment Pickup &amp; Confirmed Shift List
        </h3>
        {handlesEquipment && pickupContent ? pickupContent : (
          <div className="rounded-2xl border border-white/5 bg-slate-900/50 p-4 text-sm text-slate-400">
            No equipment pickup or confirmed equipment checklist is assigned to your role for this shift.
          </div>
        )}
      </section>

      <section aria-labelledby="gear-requests-heading" className="border-t border-white/10 pt-6">
        <h3 id="gear-requests-heading" className="mb-4 flex items-center gap-2 px-2 text-[11px] font-black uppercase tracking-[0.2em] text-yellow-500">
          <MessageSquare size={14} /> Crew Gear Requests &amp; Equipment Notes
        </h3>
        <textarea
          aria-label="Crew gear requests and equipment notes"
          className="min-h-[120px] w-full resize-y rounded-2xl border border-white/10 bg-slate-900 p-4 text-sm text-white outline-none placeholder:text-slate-600 focus:border-yellow-500/50"
          placeholder="E.g., The 360 booth motor sounded a bit loud. Or: We ran out of photo paper and need a restock!"
          value={crewNotes}
          onChange={event => onCrewNotesChange(event.target.value)}
          onBlur={event => onCrewNotesSave(event.target.value)}
        />
        <p className="ml-2 mt-2 text-[9px] font-bold uppercase tracking-widest text-slate-500">Notes auto-save when you tap outside the box.</p>
      </section>
    </div>
  );
}
